<template>
  <div>
    <v-card class="cardWrap">
      <CardTitle title="システム設定" />
      <v-tabs
          background-color="white accent-4"
          color="black"
        >
        <v-tab @click="seen = 'CellBases'">基本枠作成</v-tab>
        <v-tab :class="{ 'd-none': golfUser }" @click="seen = 'ApiKeys'">API認証キー</v-tab>
        <v-tab @click="seen = 'SystemMaster'">システム管理</v-tab>
        <v-tab @click="seen = 'CodeMaster'">名称管理</v-tab>
        <v-tab @click="seen = 'CooperationApp'">連携アプリ管理</v-tab>
        <v-tab @click="seen = 'AppPriority'">配信優先管理</v-tab>
        <v-tab @click="seen = 'AppManagement'">配信管理</v-tab>
      </v-tabs>
      <keep-alive>
        <component :is="seen" />
      </keep-alive>
    </v-card>
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import ApiKeys from './page/ApiKeys';
import CellBases from './page/CellBases';
import SystemMaster from './page/SystemMaster';
import CodeMaster from './page/CodeMaster';
import CooperationApp from './page/CooperationApp';
import AppPriority from './page/AppPriority';
import AppManagement from './page/AppManagement';
import { CODE_MASTER } from '@/views/config';

// graphql
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        CardTitle,
        ApiKeys,
        CellBases,
        SystemMaster,
        CodeMaster,
        CooperationApp,
        AppPriority,
        AppManagement
    },
    mixins: [
        authorityMixin
    ],
    data () {
        return {
            seen: 'CellBases',
            admin: {
                user_div: null
            }
        };
    },
    computed: {
        golfUser () {
            return this.admin.golf_code !== CODE_MASTER.AUTHORITY_SYSTEM_ADMIN_SUPERUSER_CODE;
        }
    },
    async created () {
        this.admin = await this.getLoginAdmin();
    }
};
</script>

<style>

</style>
